/**
 * Mock-Service für Entwicklungsumgebung
 */

// Mock Templates
const mockTemplates = [
  {
    id: "template-1",
    template_name: "Willkommens-Email",
    sender_name: "Marketing Team",
    client: "marketing",
    subject: "Willkommen bei unserem Service",
    created_at: "2023-04-15T10:00:00Z",
    mail_type: "user",
    html: "<h1>Willkommen</h1><p>Vielen Dank für Ihre Anmeldung!</p>",
    plain_text: "Willkommen\n\nVielen Dank für Ihre Anmeldung!"
  },
  {
    id: "template-2",
    template_name: "Passwort zurücksetzen",
    sender_name: "Support Team",
    client: "support",
    subject: "Passwort zurücksetzen",
    created_at: "2023-05-20T14:30:00Z",
    mail_type: "user",
    html: "<h1>Passwort zurücksetzen</h1><p>Klicken Sie auf den Link, um Ihr Passwort zurückzusetzen.</p>",
    plain_text: "Passwort zurücksetzen\n\nKlicken Sie auf den Link, um Ihr Passwort zurückzusetzen."
  },
  {
    id: "template-3",
    template_name: "Monatsabrechnung",
    sender_name: "Finanz Team",
    client: "finance",
    subject: "Ihre monatliche Abrechnung",
    created_at: "2023-06-01T09:15:00Z",
    mail_type: "user",
    html: "<h1>Monatsabrechnung</h1><p>Hier ist Ihre Abrechnung für den letzten Monat.</p>",
    plain_text: "Monatsabrechnung\n\nHier ist Ihre Abrechnung für den letzten Monat."
  }
];

// Mock Client Daten
const mockClient = {
  name: "Example Corp",
  client: "example",
  mailDomain: "example.com",
  sender_email_address: "noreply@example.com",
  email_delivery_mode: "regular_and_compliance",
  compliance_addresses: ["compliance@example.com", "legal@example.com"],
  jobFlowClient: {
    background_color: "#3498db",
    text_color: "#ffffff"
  }
};

// Mock SMTP Konfiguration
const mockSmtpConfig = {
  mail_provider: "ses", // 'ses' oder 'smtp'
  smtp_config: {
    host: "smtp.example.com",
    port: 587,
    secure: false,
    username: "noreply@example.com",
    password: "mockpassword123",
    require_tls: true,
    sender_name: "Example Corp Support",
    sender_email: "noreply@example.com"
  }
};

// Mock Session
const mockSession = {
  sessionId: "mock-session-12345",
  user: {
    id: "user-1",
    name: "Test User",
    email: "test@example.com"
  }
};

/**
 * Prüft, ob wir die Mocks verwenden sollen
 * @returns {boolean}
 */
export const shouldUseMocks = () => {
  // Für Debugging-Zwecke direkt true zurückgeben
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('URL search:', window.location.search);

  // Später, wenn API verfügbar ist, können wir zurück zu dieser Logik wechseln:
  return process.env.NODE_ENV === 'development' ||
          window.location.search.includes('use_mocks=true');
};

/**
 * Mock für JWT Login
 * @returns {Promise}
 */
export const mockLogin = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: JWT Login erfolgreich');
      resolve(mockSession);
    }, 500); // simulierte Netzwerklatenz
  });
};

/**
 * Mock für Templates abrufen
 * @returns {Promise}
 */
export const mockGetTemplates = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: Templates geladen');
      resolve(mockTemplates);
    }, 700); // simulierte Netzwerklatenz
  });
};

/**
 * Mock für Template erstellen
 * @param {Object} templateData
 * @returns {Promise}
 */
export const mockCreateTemplate = (templateData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: Template erstellt', templateData);
      const newTemplate = {
        id: `template-${Date.now()}`,
        ...templateData,
        created_at: new Date().toISOString(),
        mail_type: "user"
      };
      resolve(newTemplate);
    }, 800);
  });
};

/**
 * Mock für Template aktualisieren
 * @param {string} templateId
 * @param {Object} templateData
 * @returns {Promise}
 */
export const mockUpdateTemplate = (templateId, templateData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: Template aktualisiert', templateId, templateData);
      resolve({
        id: templateId,
        ...templateData,
        updated_at: new Date().toISOString()
      });
    }, 800);
  });
};

/**
 * Mock für Template löschen
 * @param {string} templateId
 * @returns {Promise}
 */
export const mockDeleteTemplate = (templateId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: Template gelöscht', templateId);
      resolve({ success: true, id: templateId });
    }, 600);
  });
};

/**
 * Mock für Client-Daten abrufen
 * @returns {Promise}
 */
export const mockGetClientSettings = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: Client-Einstellungen geladen');
      resolve(mockClient);
    }, 500);
  });
};

/**
 * Mock für Client-Daten aktualisieren
 * @param {Object} clientData
 * @returns {Promise}
 */
export const mockUpdateClientSettings = (clientData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: Client-Einstellungen aktualisiert', clientData);
      resolve({
        ...mockClient,
        ...clientData,
        updated_at: new Date().toISOString()
      });
    }, 700);
  });
};

/**
 * Mock für SMTP-Konfiguration abrufen
 * @returns {Promise}
 */
export const mockGetSmtpConfig = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: SMTP-Konfiguration geladen');
      resolve(mockSmtpConfig);
    }, 500);
  });
};

/**
 * Mock für SMTP-Konfiguration aktualisieren
 * @param {Object} smtpData
 * @returns {Promise}
 */
export const mockUpdateSmtpConfig = (smtpData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock: SMTP-Konfiguration aktualisiert', smtpData);
      Object.assign(mockSmtpConfig, smtpData);
      resolve({
        ...mockSmtpConfig,
        updated_at: new Date().toISOString()
      });
    }, 700);
  });
};

/**
 * Mock für SMTP-Verbindungstest
 * @param {Object} smtpData
 * @returns {Promise}
 */
export const mockTestSmtpConnection = (smtpData) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      console.log('Mock: SMTP-Verbindungstest', smtpData);
      
      // Wenn nicht SMTP als Provider gewählt ist, fehlschlagen
      if (smtpData.mail_provider !== 'smtp') {
        reject({
          success: false,
          message: 'Kein SMTP-Provider konfiguriert'
        });
        return;
      }
      
      // Simulieren eines erfolgreichen Tests wenn Host und Port vorhanden
      if (smtpData.smtp_config && smtpData.smtp_config.host && smtpData.smtp_config.port) {
        resolve({ success: true, message: 'SMTP-Verbindung erfolgreich hergestellt' });
      } else {
        reject({ 
          success: false, 
          message: 'SMTP-Verbindung fehlgeschlagen: Unvollständige Konfiguration'
        });
      }
    }, 1500);
  });
};

export default {
  shouldUseMocks,
  mockLogin,
  mockGetTemplates,
  mockCreateTemplate,
  mockUpdateTemplate,
  mockDeleteTemplate,
  mockGetClientSettings,
  mockUpdateClientSettings,
  mockGetSmtpConfig,
  mockUpdateSmtpConfig,
  mockTestSmtpConnection
};
